import { isLegacyGravatarUrl } from "@/ui";

/**
 * Whether a stored photo URL is one we should ignore and fall back to initials.
 *
 * Only covers "nothing stored" and the legacy `d=mm` gravatar URLs the API used
 * to assign on candidate creation. Those always resolved to gravatar's own grey
 * silhouette, so they were indistinguishable from a real photo and had to be
 * discarded on sight — which meant candidates with a genuine gravatar never saw
 * it.
 *
 * A `d=404` gravatar URL is NOT a placeholder: the API stores one only once it
 * has confirmed gravatar has an image for the address.
 *
 * Narrower than `isStandInAvatar`, deliberately. This decides whether to render
 * the value at all; that decides whether what rendered is worth blurring, and so
 * also counts the generic icon, which is a perfectly good thing to display.
 */
export default function isPlaceholderPhoto(photoUrl?: string | null): boolean {
  if (!photoUrl) {
    return true;
  }

  return isLegacyGravatarUrl(photoUrl);
}
